import { ChangeDetectionStrategy, Component, OnInit, input } from '@angular/core';
import { faUsers, faIdBadge, faFileLines, faFileInvoiceDollar, faFileCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { BehaviorSubject, Subject } from 'rxjs';
import { AssessmentService } from 'src/app/services/assessment.service';
import { DialogService } from 'src/app/services/dialog.service';
import { ReportService } from 'src/app/services/report.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-fire-overview',
  templateUrl: './fire-overview.component.html',
  styleUrl: './fire-overview.component.scss',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class FireOverviewComponent implements OnInit {
  faFileLines = faFileLines;
  faIdBadge = faIdBadge;
  faUsers = faUsers;
  faFileInvoiceDollar = faFileInvoiceDollar;
  faFileCircleCheck = faFileCircleCheck;

  assessment_id = input.required<number>();
  tab = input.required<number>();
  report_num = input.required<number>();

  user: any;
  assessment: any;
  reports: any;
  fireObs = new BehaviorSubject<any>(null);
  updateFireSubject = new Subject<any>();


  //access
  isEditable: boolean = false;

  tabIndex = 0;

  constructor(
    public userService: UserService,
    private readonly assessmentService: AssessmentService,
    private readonly dialogService: DialogService,
    private readonly reportService: ReportService,
  ) {
    this.updateFireSubject.subscribe((res: any) => {
      if (res == null) {
        this.loadAssessments()
      }
    })
  }

  ngOnInit() {
    if (this.tab()) {
      this.tabIndex = this.tab()
    }
    this.loadAssessments();
  }

  loadUser() {
    this.userService.getUserProfile().then(async (user) => {
      this.user = user;
      if (user.teamLeadRoles && (this.assessment.team_lead?.user_id == user.user_id)) {
        this.user.isTeamLead = true;
      } else {
        this.user.isTeamLead = false;
      }

      if ((this.user.isWOCO.length >= 1) ||
        (this.user.isTeamLead && (this.assessment.team_lead?.user_id == user.user_id)) ||
        (this.user.isFOCO.some((forestName: string) => this.assessment.forest_name.includes(forestName))) ||
        (this.user.isROCO.some((region: string) => this.assessment.region.includes(region)))
      ) this.isEditable = true;

      this.reports.forEach((report: any) => {
        report.users.forEach((member: any) => {
          if (user.teamLeadRoles && (this.user.user_id == member.user_id) && [0, 1].includes(member.role_id) && member.editor && !member.demobilize) this.isEditable = true;
        })
      });
    });
  }

  loadAssessments() {
    this.dialogService.openSpinner();
    this.assessmentService.getAssessmentByID(this.assessment_id()).subscribe({
      next: (assessment) => {
        this.assessment = assessment;
        this.fireObs.next(this.assessment);
      },
      complete: () => {
        this.dialogService.closeSpinner();
      }
    });
    let reportRelations = '&relations=users.skills,supports,assessment,users.user.skills,comments,forests.treatments.treatment_specifications,signatures';

    this.reportService.getReportList(this.assessment_id(), reportRelations).subscribe({
      next: (data) => {
        data.reports.sort((reportA: any, reportB: any) => reportA.report_num - reportB.report_num)
        this.reports = data.reports;
        this.assessment.reports = data.reports;
        this.setReportComments();
        this.loadUser();
        this.updateFireSubject.next({ "reports": this.reports })
      }
    });
  }

  setReportComments() {
    this.reports.forEach((report: any) => {
      let findUnresolved = report.comments.find((x: any) => !x.resolved)
      if (findUnresolved ?? false) report.comments_unresolved = true;
    });
  }
}
